import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Callout, Checkbox, Tooltip,ProgressBar } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation,Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'
import svgdoubledown from './svg/double-chevron-down.svg'

import {FiniInfo,  PrintChqInfo} from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';
import { useHistory } from "react-router-dom";

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}


interface PageInfo {
    n: number
}

interface PageInfo2 {
    pageno: number,
    pageShow: boolean,
    pageStartno: number,
    pageEndno: number,
    pageLast: boolean,
}

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}


var GsbFlag: any;

var UserID: string;
var PgmCode = "I0011" ;
var isReqAuth2:boolean = false ;



interface PrintChqRtnProps {
    gsb: AxiosInstance,
    currentPrintChq?: PrintChqInfo,
    currentIpo?: FiniInfo,
    onChqProcess?: (Chq: PrintChqInfo) => void,
    onCancel?: () => void;
}

function PrintChqRtn({ gsb, currentPrintChq = {} as PrintChqInfo, currentIpo = {} as FiniInfo, onChqProcess = () => { }, onCancel = () => { } }: PrintChqRtnProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<PrintChqInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [Enter2tab, setEnter2tab] = useState("Y")

    const [IPAddr, setIPAddr] = useState("")

    const [ShowButton, setShowButton] = useState(true)
    
    const [BankCodeValue, setBankCodeValue] = useState(currentPrintChq.d_Bank_Code)
    const [ChequeDateValue, setChequeDateValue] = useState(currentPrintChq.d_Cheque_Date)
    const [StartingChequeNoValue, setStartingChequeNoValue] = useState(currentPrintChq.d_Starting_Cheque_No)
    const [LPTValue, setLPTValue] = useState(currentPrintChq.d_LPT)


    useEffect(() => {
        // Call reset to get the values of record PfEntitInfo 
        if ("d_Bank_Code" in currentPrintChq) {
            reset(currentPrintChq)
        }
    }, [currentPrintChq, reset])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        //register({ name: "d_Currency" })
    }, [register])


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setEnter2tab(GsbFlag.Enter2tab)               

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, currentIpo, GsbFlag])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [gsb, currentPrintChq, GsbFlag, Enter2tab])


    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/Master', {
                sb_data: currentIpo, 
                cPgmId: "IPOEntry",
                cAction: "GetRefundChequeInfo",
            })                
            if ( res.data.count > 0 ) {
                setBankCodeValue(res.data.data["d_Bank_Code"])
                setChequeDateValue(res.data.data["d_Cheque_Date"])
            }

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, currentPrintChq, GsbFlag])


    const onSubmit = (data: PrintChqInfo) => {

        setShowButton(false)

        data.d_Bank_Code = BankCodeValue;
        if ( typeof(data.d_Bank_Code) === "undefined" ) {
            data.d_Bank_Code = ""
        }
        data.d_Bank_Code = data.d_Bank_Code.toUpperCase();

        data.d_LPT = LPTValue;
        data.d_LPT = data.d_LPT.toUpperCase();

        data.d_Starting_Cheque_No = StartingChequeNoValue;
        if ( typeof(data.d_Starting_Cheque_No) === "undefined" ) {
            data.d_Starting_Cheque_No = "1"
        }

        data.d_StkNo = currentIpo.d_StkNo;
       

        (async () => {
            try {
                
                console.log("call PrintChqRtn data", data);

/*
                const res = await gsb.post('/Master', {sb_data: data, cPgmId: "IPOEntry", cAction: "PrintChqValidate" })
                //console.log("PrintChqRtn res.data.ok", res.data.ok)
                //console.log("PrintChqRtn res.data.daa", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    setShowButton(true)
                    
                    return
                }
*/
                onChqProcess(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

    }




    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Exit</Button>
                <Button className="Col-2-2" disabled={! ShowButton} icon="tick" onClick={handleSubmit(onSubmit)}>Print Cheque</Button>
             </div>
            <div className="Spacing-V-16" />

            <div className="Row">
                <FormGroup className="Col-1-2" label="Bank Code" labelFor="inputBank_Code" labelInfo="*">
                    <InputGroup id="inputBank_Code" value={BankCodeValue} defaultValue="" placeholder="Bank Code ..." onChange={utils.handleStringChange(s => setBankCodeValue(s)) } inputRef={register({ required: true , maxLength: 8}) } />
                    {errors.d_Bank_Code && errors.d_Bank_Code.type === "required" && <span id="Err_msg">Bank Code cannot be Blank</span>}
                    {errors.d_Bank_Code && errors.d_Bank_Code.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_Bank_Code && errors.d_Bank_Code.types && <span id="Err_msg">{errors.d_Bank_Code.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Cheque Date" labelFor="inputCheque_Date">
                    <InputGroup id="inputCheque_Date" name="d_Cheque_Date" type="date" defaultValue={ChequeDateValue} placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register} />
                    {errors.d_Cheque_Date && errors.d_Cheque_Date.types && <span id="Err_msg">{errors.d_Cheque_Date.types.message}</span>}
                </FormGroup>
            </div>
             
            <div className="Spacing-V-16" />

            <div className="Row">
                <FormGroup className="Col-1-2" label="Starting Cheque No" labelFor="inputChequeNo">
                    <InputGroup className="inputNumberNoSpin" id="inputChequeNo" defaultValue={StartingChequeNoValue} value={StartingChequeNoValue} type="number" onChange={utils.handleStringChange(n => setStartingChequeNoValue(n))}  />
                    {errors.d_Starting_Cheque_No && errors.d_Starting_Cheque_No.types && <span id="Err_msg">{errors.d_Starting_Cheque_No.types.message}</span>}
                </FormGroup>
            </div>

            <div className="Row">
                <FormGroup className="Col-1-2" label="XLPT" labelFor="inputLpt" labelInfo="*">
                    <InputGroup id="inputLpt" value={LPTValue} defaultValue="" placeholder="XLPT ..." onChange={utils.handleStringChange(s => setLPTValue(s)) } inputRef={register({ required: true ,maxLength: 5}) } />
                    {errors.d_LPT && errors.d_LPT.type === "required" && <span id="Err_msg">XLPT cannot be Blank</span>}
                    {errors.d_LPT && errors.d_LPT.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_LPT && errors.d_LPT.types && <span id="Err_msg">{errors.d_LPT.types.message}</span>}
                </FormGroup>
            </div>

        </form>
    )
}


interface ResetChqRtnProps {
    gsb: AxiosInstance,
    currentPrintChq?: PrintChqInfo,
    currentIpo?: FiniInfo,
    onResetChqProcess?: (Chq: PrintChqInfo) => void,
    onCancel?: () => void;
}

function ResetChqRtn({ gsb, currentPrintChq = {} as PrintChqInfo, currentIpo = {} as FiniInfo, onResetChqProcess = () => { }, onCancel = () => { } }: ResetChqRtnProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<PrintChqInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [Enter2tab, setEnter2tab] = useState("Y")

    const [IPAddr, setIPAddr] = useState("")

    const [ShowButton, setShowButton] = useState(true)
    
    const [BankCodeValue, setBankCodeValue] = useState(currentPrintChq.d_Bank_Code)
    const [ChequeDateValue, setChequeDateValue] = useState(currentPrintChq.d_Cheque_Date)
    const [ResetChequeNoValue, setResetChequeNoValue] = useState(currentPrintChq.d_Reset_Cheque_No)
    const [AutopayBankCodeValue, setAutopayBankCodeValue] = useState(currentPrintChq.d_Autopay_BankCode)


    useEffect(() => {
        // Call reset to get the values of record PfEntitInfo 
        if ("d_Bank_Code" in currentPrintChq) {
            reset(currentPrintChq)
        }
    }, [currentPrintChq, reset])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        //register({ name: "d__Currency" })
    }, [register])


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setEnter2tab(GsbFlag.Enter2tab)               

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, currentPrintChq, GsbFlag])


    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [gsb, currentPrintChq, GsbFlag, Enter2tab])



    const onSubmit = (data: PrintChqInfo) => {

        setShowButton(false)

        data.d_Bank_Code = BankCodeValue;
        if ( typeof(data.d_Bank_Code) === "undefined" ) {
            data.d_Bank_Code = ""
        }
        data.d_Bank_Code = data.d_Bank_Code.toUpperCase();


        data.d_Reset_Cheque_No = ResetChequeNoValue;
        if ( typeof(data.d_Reset_Cheque_No) === "undefined" ) {
            data.d_Reset_Cheque_No = "1"
        }

        data.d_Autopay_BankCode = AutopayBankCodeValue;
        if ( typeof(data.d_Autopay_BankCode) === "undefined" ) {
            data.d_Autopay_BankCode = ""
        }
        data.d_Autopay_BankCode = data.d_Autopay_BankCode.toUpperCase();

        data.d_StkNo = currentIpo.d_StkNo;
       

        (async () => {
            try {
                
                console.log("call ResetChqRtn data", data);

                
                onResetChqProcess(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

    }



    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Exit</Button>
                <Button className="Col-2-4" disabled={! ShowButton} icon="tick" onClick={handleSubmit(onSubmit)}>Reset Refund Cheque No. / "Export Cheque to File"</Button>
             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="Reset Refund Cheque No. Starting From" labelFor="inputReset_Cheque_No" labelInfo="*">
                    <InputGroup id="inputReset_Cheque_No" value={ResetChequeNoValue} defaultValue="1" placeholder="Cheque No. ..." onChange={utils.handleStringChange(s => setResetChequeNoValue(s)) } inputRef={register({ required: true , maxLength: 6}) } />
                    {errors.d_Reset_Cheque_No && errors.d_Reset_Cheque_No.type === "required" && <span id="Err_msg">Bank Code cannot be Blank</span>}
                    {errors.d_Reset_Cheque_No && errors.d_Reset_Cheque_No.type === "maxLength" && <span id="Err_msg">Max length is 6</span>}
                    {errors.d_Reset_Cheque_No && errors.d_Reset_Cheque_No.types && <span id="Err_msg">{errors.d_Reset_Cheque_No.types.message}</span>}
                </FormGroup>
            </div>
            
            <div className="Spacing-V-16" />
            <div className="Spacing-V-16" />
            <div >Note : </div>
            <div >You may key in "1" or "e-PAID" to reset all Refund Cheque No / "Export Cheque to File" to blank</div>
        </form>
    )
}
    

interface PrintRefundChqRtn02MainProps {
    gsb: AxiosInstance,
    IPO: FiniInfo,
    baseUrl?: string,
    token?: string | null,
   
    ViewMode: any,
    logKey2: any,
}


// Print Refund Chq
function  PrintRefundChqRtn02Main({ gsb, IPO = {} as FiniInfo, baseUrl = "", token = "",   ViewMode, logKey2 }: PrintRefundChqRtn02MainProps) {
    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const imgdoubledown = <img className="svgdoubledownIcon" src={svgdoubledown} height="20" width="30" alt="doubledown" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />
    const history = useHistory()
 
    let ProgressId2 = ""

    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)
    const [ImportGSBMsg, setImportGSBMsg] = useState("")    
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme1") 
    const [isReplicate, setisReplicate] = useState(false)
    const [isRegenbcan, setisRegenbcan] = useState(false)

    const { t, i18n } = useTranslation();

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
 

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptHead2, setRptHead2] = useState("")
    const [RptName, setRptName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    const [ShowWait, setShowWait] = useState(false)
    const [ChgPrintCheque, setChgPrintCheque] = useState(false)
    const [ChgAutopay, setChgAutopay] = useState(false)

    const [ShowRpt, setShowRpt] = useState(false)

    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
 
    const [s_StkNo1, sets_StkNo1] = useState("")
    const [DataFormatValue, setDataFormatValue] = useState(false)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
     
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)


    //const [cPrintMode, setcPrintMode] = useState("PS")
    const [LineLimit, setLineLimit] = useState(54 - 7)
    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FiniInfo>()
  
    const[File_Indicator,setFile_Indicator] = useState("")

    const[ResetFile_Indicator,setResetFile_Indicator] = useState("")

    const[RstByAppyDate,setRstByAppyDate]=  useState(utils.formatNumber(new Date()))

 
    const [MoblieDev, setMoblieDev] = useState(false)
 
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(IPO.d_StkNo)
    const [showFilters, setShowFilters] = useState(false)
    const [data, setData] = useState([] as FiniInfo[])
    const [currentAc, setCurrentAc] = useState({} as FiniInfo)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [isResetPress, setisResetPress] = useState(false)
 
    const [BlankPrintChq, setBlankPrintChq] = useState({} as PrintChqInfo)
    const [currentMode, setcurrentMode] = useState("MenuMode")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    const [isShowAlert3, setisShowAlert3] = useState(false)
    const [ShowAlert3Msg, setShowAlert3Msg] = useState([])

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [CCHQ_FILE, setCCHQ_FILE] = useState(false)

    const [isGenerate, setisGenerate] = useState(false)
    
    BlankPrintChq.d_Bank_Code = ""
    BlankPrintChq.d_Starting_Cheque_No = "1"
    BlankPrintChq.d_Reset_Cheque_No = "e-PAID"
    BlankPrintChq.d_LPT = "XLPT1"
    BlankPrintChq.d_Autopay_BankCode = ""


    useEffect(() => {
        setShowRpt(false)        
        setShowNoRecord(false)     
        setShowOK(true)
    }, [IPO.d_StkNo, DataFormatValue])


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setCCHQ_FILE(GsbFlag.CCHQ_FILE);

               
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
        
    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax
                            //console.log("Progresslist: ", res.data.data[0].progressValue, res.data.data[0].progressMax) 
                            //console.log("Progresslist pValue: ", pValue) 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 20*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])


    const onPrintRefundCheque = (PrintChq: PrintChqInfo) => {
        setShowWait(true)
        setRptName("")
        setRptNameNo(0)
        ;
        console.log("onPrintRefundCheque PrintChq", PrintChq);
        (async () => {
            try {
                const res = await gsb.post('/Master', {
                    sb_data: PrintChq, 
                    cPgmId: "IPOEntry",
                    cAction: "PrintRefundCheque",
                })                
                if ( res.data.ok ) {
                    //utils.showSuccess(res.data.data)
                    setisShowAlert1(true)
                    setShowAlert1Msg(res.data.data)
                    setRptName(res.data.RptName)
                    setRptNameNo(res.data.RptNameNo)
                    if ( res.data.count > 0 ) {
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    //utils.showWarn(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        setChgPrintCheque(true)
}

    const onCCHQ_FILE = () => {
        setShowWait(true)
        setRptName("")
        setRptNameNo(0)
        ;
        console.log("onDIVCHQ_TO_BANK currentIpo", IPO);
        (async () => {
            try {
                const res = await gsb.post('/Master', {
                    sb_data: IPO, 
                    cPgmId: "IPOEntry",
                    cAction: "IPOChq_to_Bank",
                })                
                if ( res.data.ok ) {
                    //utils.showSuccess(res.data.data)
                    setisShowAlert1(true)
                    setShowAlert1Msg(res.data.data)
                } else {
                    //utils.showWarn(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        setChgAutopay(true)
}

    const onChqProcess = async (PrintChq: PrintChqInfo) => {
        onPrintRefundCheque(PrintChq)
    }

    const onResetChqProcess = async (PrintChq: PrintChqInfo) => {
        setShowWait(true)
        setRptName("")
        setRptNameNo(0)
        ;
        console.log("onResetChqProcess PrintChq", PrintChq);
        (async () => {
            try {
                const res = await gsb.post('/Master', {
                    sb_data: PrintChq, 
                    cPgmId: "IPOEntry",
                    cAction: "ResetRefundCheque",
                })                
                if ( res.data.ok ) {
                    //utils.showSuccess(res.data.data)
                    setisShowAlert1(true)
                    setShowAlert1Msg(res.data.data)
                } else {
                    //utils.showWarn(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
        setShowWait(false)
        if ( PrintChq.d_Reset_Cheque_No == "AUTOPY" ) {
            setChgAutopay(true)
        } else {
            setChgPrintCheque(true)
        }
    }


    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }
    
    const onSubmit = () => {

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
    }
    
    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>}
        <div className="Spacing-V-16" />
        Please download the Cheque file to Print at the above link !!
    </>

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }



    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    //console.log("tasklist res.data.data", res.data.data)
                    setTaskList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            }, 3*1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])


    let PrintChqSection = <PrintChqRtn gsb={gsb} currentPrintChq={BlankPrintChq} currentIpo={IPO} onChqProcess={onChqProcess} onCancel={() => { setcurrentMode("MenuMode") } } ></PrintChqRtn>

    let ResetChqSection = <ResetChqRtn gsb={gsb} currentPrintChq={BlankPrintChq} currentIpo={IPO} onResetChqProcess={onResetChqProcess} onCancel={() => { setcurrentMode("MenuMode") } } ></ResetChqRtn>


  let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (     
        <form onKeyDown={handleHotkey}>
            <div >
                <div >
                    <H3>Print Refund Cheque for Stock ({IPO.d_StkNo})</H3>
                </div>
                <div className="Spacing-V-16" />
                {ShowWait && <div>{imgWait}</div> }
                <div className="Spacing-V-16" />
                <FormGroup className="Col-1-12"  >
                    { ( currentMode == "MenuMode" ) && <table>
                        <tr><td><Button className="Col-3-2" icon="document" onClick={() => { setcurrentMode("PrintChqMode")  } }>Print Refund Cheque to Client</Button></td></tr>
                        <tr><td id="td_center">&nbsp;</td></tr>
                        <tr><td><Button className="Col-3-2" disabled={! CCHQ_FILE} icon="document" onClick={() => { setisGenerate(true) } }>Export Cheque Record to File</Button></td></tr>
                        <tr><td id="td_center">&nbsp;</td></tr>
                        <Alert
                            cancelButtonText="Cancel"
                            confirmButtonText="Generate"
                            canEscapeKeyCancel={true}
                            icon="flow-branch"
                            intent={Intent.SUCCESS}
                            isOpen={isGenerate}
                            onCancel={ () => setisGenerate(false) }
                            onConfirm={ () => { onCCHQ_FILE(); setisGenerate(false) } }
                        >
                            <p>
                                Are you sure to Export Cheque Record to File ?
                            </p>
                        </Alert>                        
                        <tr><td><Button className="Col-3-2" icon="document" onClick={() => { setcurrentMode("ResetChqMode")  } }>Reset Refund Cheque No./ "Export Cheque to File" to Blank</Button></td></tr>
                        <tr><td id="td_center">&nbsp;</td></tr>
                    </table> }
                    <div className="Spacing-V-16" />
                    { ( currentMode == "PrintChqMode" ) && <div >
                        {PrintChqSection}
                        {RptName.trim().length > 0 && RptNameaRef}
                    </div> }
                    { ( currentMode == "ResetChqMode" ) && <div >
                        {ResetChqSection}
                    </div> }
                    <div className="Spacing-V-16" />
                </FormGroup>    
                <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert3}
                    onCancel={ () => setisShowAlert3(false) }
                    onConfirm={ () => { setShowAlert3Msg([]); setisShowAlert3(false) } }
                >
                    <p>
                        {/*ShowAlert3Msg*/}
                        <div className="Spacing-V-16"></div>
                        {ShowAlert3Msg.map((Wmsg, j) => 
                            <div>{ShowAlert3Msg[j]}</div>
                        )}
                    </p>
                </Alert>
            </div>
        </form>  
    )
}


interface IPORefundChqMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function IPORefundChqMain({ gsb }: IPORefundChqMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "" }: { acCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [data, setData] = useState([] as FiniInfo[])


    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)

    const [searchStkNo, setSearchStkNo] = useState("")
    const [searchStkName, setSearchStkName] = useState("")
    const [searchApplyDate, setsearchApplyDate] = useState("")

    const [def_id_Type, setid_Type] = useState("")

    const [searchTel, setSearchTel] = useState("")


    const [s_AcStatus, sets_AcStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])

    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    

    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as FiniInfo)
    const [BlankAc, setBlankAc] = useState({} as FiniInfo)
    const [CurrentLog, setCurrentLog] = useState({} as FiniInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme1")
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
    
    const { t, i18n } = useTranslation();
   
    const [isDeletePress, setisDeletePress] = useState(false)
    const history = useHistory()

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("HkidrMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("HkidrMastMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("HkidrMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("HkidrMastMain disp GsbFlag: ", GsbFlag)
                //console.log("HkidrMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("HkidrMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                UserID = res.data.Flag.UserID
                //console.log("HkidrMastMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("HkidrMastMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("HkidrMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSUSPEND_AC(GsbFlag.SUSPEND_AC);

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("HkidrMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            //setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                //showErrorBox(error)
                //utils.showError(error)
            }
        })()            
    }, [gsb, UserID])


 

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        try {
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        PageShowInfo: aPageShowInfo,
                        refreshPageShow: true,
                        backward: searchBackward,
                        SortByName: false,
                        filters: {
                            StkNo: searchStkNo,
                            StkName: searchStkName,
                            AppyDate:searchApplyDate,
                        },
                        IsShowGenOnly : false,
                        IsGENIPO : false,
                        IsAPost: false,
                    },
                    cPgmId: "IPOMast",
                    cAction: "ListRecByStkNo",
                });

                //console.log("ListRec res.data.data", res.data.data)
                //console.log("ListRec res.data.count", res.data.count)
                setData(res.data.data)
                setaPageShowInfo(res.data.PageShowInfo)

                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }

            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_acCode: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "IPOMast",
                    cAction: "GetRecIPO",
                });

                if ( res.data.ok ) {
                    //console.log("GetRecIPO res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                    alert(res.data.data)
                }
            }
            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }
 
    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
 
                    const res = await gsb.post('/Master',
                        {   sb_data: {
                                by: searchKey,
                                start: searchValue,
                                nPage: nPage,                               
                                limit: searchLimit,
                                PageShowInfo: aPageShowInfo,
                                refreshPageShow: false,                      
                                backward: searchBackward,
                                SortByName: false,
                                IsShowGenOnly: false,   
                                IsAPost: true,   
                                IsGENIPO: false,
                            },
                            cPgmId: "IPOMast",
                            cAction: "ListRecByStkNo",
                        });


                    setData(res.data.data)
                    setaPageShowInfo(res.data.PageShowInfo)

                    if ( res.data.count > 0 ) {
                        const aPageNumber1 = []
                        let k = 0
                        for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                            if ( res.data.PageShowInfo[j-1].pageShow ) {
                                k++
                                aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                                if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                    setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                    setPageReachEnd(true)
                                }
                            }
                        }
                        setaPageNumber(aPageNumber1)
                        //console.log("ListRec Press k", k, aPageNumber1)
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    } 


    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail =< PrintRefundChqRtn02Main gsb={gsb} IPO={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')}  ViewMode={ViewMode} logKey2={logKey2.trim()} ></ PrintRefundChqRtn02Main>
    let logKeyViewRec = < PrintRefundChqRtn02Main gsb={gsb} IPO={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} ViewMode={ViewMode} logKey2={logKey2.trim()} ></ PrintRefundChqRtn02Main>
 
    function PageNo(n: number) {
        if (n > 0 ) {
            if (  nPage+n <= nTotalPage || nTotalPage == 0 ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }
  
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                    {aPageNumber.map((no, j) => 
                    (no.n < nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (no.n > nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
                { (nPage > 0) && ! ( PageReachEnd ) &&
                    <Button minimal >...</Button>
                }
            </FormGroup>
        </div>
    </>

    let list = <>
        <div className="Row">
            {/* <Button className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button> */}
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}

      
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">Stock</th>
                <th className="TCol-StkName">Stock Name</th>
                 {/*<th className="TCol-ACCode">LOT SIZE</th>*/}
                <th className="TCol-ACCode">Apply date</th>
                <th className="TCol-ACCode">List date</th>    
                <th className="TCol-APrice">Apply Price</th>
                <th className="TCol-ACCode">List Price</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((IPO, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-ACCode" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>{IPO.d_StkNo}</td>
                        <td className="TCol-StkName" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>{IPO.d_StkCode}</td>
                        {/*<td className="TCol-ACCode" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>{IPO.OAQTY}</td> */}
                        <td className="TCol-ACCode" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(IPO.d_ApplyDate, GsbFlag.dateFormat)}</td>                      
                        <td className="TCol-ACCode" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>{utils.dispDate(IPO.d_ListingDate, GsbFlag.dateFormat)}</td>
                        <td className="TCol-ACCode" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>${utils.formatNumber2(IPO.d_ApplyPrice)}</td>
                        <td className="TCol-APrice" onClick={() => { setCurrentAc(IPO) ; MoblieDev && setSelectedTabId("detail") }}>${utils.formatNumber2(IPO.d_OIPRICE)}</td>
                    </tr>
                )}
            </tbody>
         
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
   
   
   
    return (
        <>
           
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>           
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead} 
                    </FormGroup>
                </div>
     
                { ! ( logviewonly === "Y" ) &&  <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                
                    {(selectedTabId === "list") && <H3><div style={{justifyContent: 'flex-end'}}>Print Refund Cheque</div></H3> }
                    
                    {(selectedTabId === "list") && <div className="Row No-Print">
                        <FormGroup className="Col-1-5" label="Search for IPO Master" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="StkNo">StockNo</option>
                                    <option value="StkName">StockName</option>
                                    {/* <option value="_recordNo">Record No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" type="submit" >List</Button>
                        {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                        {/*<Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>*/}
                   
                    </div> }
                    {(selectedTabId === "list") && <Collapse isOpen={showFilters}> 
                        <div className="Row">
                           <FormGroup className="Col-1-1" label="Stock Code" labelFor="searchStkNo">
                                <InputGroup id="searchStkNo" value={searchStkNo} onChange={utils.handleStringChange(s => setSearchStkNo(s))} />
                            </FormGroup>   
                            <FormGroup className="Col-1-1" label="Stock Name" labelFor="searchStkName">
                                <InputGroup id="searchStkName" value={searchStkName} onChange={utils.handleStringChange(s => setSearchStkNo(s))} />
                            </FormGroup>
                        </div>
                    </Collapse> }
                       
                    {(selectedTabId === "list") &&  <div>
                        {list} 
                    </div>}
                    {(selectedTabId === "detail") &&  <div>
                        <Button icon="arrow-left" onClick={() => setSelectedTabId("list")}>Back</Button>
                        {detail} 
                    </div>}
                </Card> }
                
            </form>
        </>
    );
}

export default IPORefundChqMain